import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import { Text, Classes } from '@blueprintjs/core';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import React__default, { forwardRef, Children } from 'react';
import { Icon } from '../icon/icon.js';
import cx from 'classnames';
import { ChevronRight20 } from '@carbon/icons-react';
import { intentPrimary, textHeading, text } from '../theme/theme.js';

var _excluded = ["className", "intent", "multiline", "text", "label", "labelIcon", "icon", "children"],
    _excluded2 = ["asChild", "children", "className", "description", "icon", "intent", "label", "labelIcon", "multiline", "onClick", "text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledIcon = /*#__PURE__*/_styled(Icon, {
  target: "e1s9k0n40"
})(".bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):hover &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):focus &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):active &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled).bp3-active &{color:", intentPrimary, " !important;}");

var StyledText = /*#__PURE__*/_styled(Text, {
  target: "e1s9k0n41"
})("font-weight:", function (_ref) {
  var hasDescription = _ref.hasDescription;
  return hasDescription && "600";
}, ";.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled) &{color:", function (_ref2) {
  var hasDescription = _ref2.hasDescription;
  return hasDescription && textHeading;
}, ";}.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):hover &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):focus &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):active &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled).bp3-active &{color:", intentPrimary, ";}");

var Description = /*#__PURE__*/_styled("div", {
  target: "e1s9k0n42"
})("font-size:0.75rem;font-weight:400;line-height:1.3333;white-space:normal;.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled) &{color:", text, ";}.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):hover &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):focus &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):active &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled).bp3-active &{color:", intentPrimary, ";}");

var StyledLabel = /*#__PURE__*/_styled("div", {
  target: "e1s9k0n43"
})(".bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):hover &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):focus &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled):active &,.bp3-menu-item:not([class*=\"intent\"]):not(.bp3-disabled).bp3-active &{color:", intentPrimary, " !important;}");

var InnerItem = function InnerItem(_ref3) {
  var children = _ref3.children,
      description = _ref3.description,
      IconIncoming = _ref3.icon,
      label = _ref3.label,
      LabelIcon = _ref3.labelIcon,
      multiline = _ref3.multiline,
      text = _ref3.text;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, IconIncoming && /*#__PURE__*/React__default.createElement(StyledIcon, null, /*#__PURE__*/React__default.createElement(IconIncoming, null)), /*#__PURE__*/React__default.createElement(StyledText, {
    className: Classes.FILL,
    ellipsize: !multiline,
    hasDescription: !!description
  }, text !== null && text !== void 0 ? text : null, description && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, " "
  /* Truncated title attribute requires an extra space. */
  , /*#__PURE__*/React__default.createElement(Description, null, description)), children !== null && children !== void 0 ? children : null), (label || LabelIcon) && /*#__PURE__*/React__default.createElement(StyledLabel, {
    className: Classes.MENU_ITEM_LABEL
  }, label !== null && label !== void 0 ? label : null, LabelIcon && /*#__PURE__*/React__default.createElement(Icon, null, /*#__PURE__*/React__default.createElement(LabelIcon, null))));
};

var DropdownMenuSubTrigger = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
      intent = _ref4.intent,
      multiline = _ref4.multiline,
      text = _ref4.text,
      label = _ref4.label,
      labelIcon = _ref4.labelIcon,
      icon = _ref4.icon,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded);

  var classes = cx(className, Classes.intentClass(intent), Classes.MENU_ITEM, _defineProperty({}, Classes.DISABLED, props.disabled));
  var innerItemProps = {
    multiline: multiline,
    text: text,
    label: label,
    labelIcon: labelIcon !== null && labelIcon !== void 0 ? labelIcon : ChevronRight20,
    icon: icon
  };
  return /*#__PURE__*/React__default.createElement("li", {
    ref: ref
  }, /*#__PURE__*/React__default.createElement(RadixDropdownMenu.TriggerItem, {
    className: classes
  }, /*#__PURE__*/React__default.createElement(InnerItem, innerItemProps, children)));
});
var DropdownMenuItem = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var asChild = _ref5.asChild,
      children = _ref5.children,
      className = _ref5.className,
      description = _ref5.description,
      icon = _ref5.icon,
      intent = _ref5.intent,
      label = _ref5.label,
      labelIcon = _ref5.labelIcon,
      multiline = _ref5.multiline,
      onClick = _ref5.onClick,
      text = _ref5.text,
      props = _objectWithoutProperties(_ref5, _excluded2);

  var classes = cx(className, Classes.intentClass(intent), Classes.MENU_ITEM, _defineProperty({}, Classes.DISABLED, props.disabled));
  var innerItemProps = {
    description: description,
    icon: icon,
    label: label,
    labelIcon: labelIcon,
    multiline: multiline,
    text: text
  };
  var newChildren = /*#__PURE__*/React__default.createElement(InnerItem, innerItemProps, children);

  if (asChild) {
    Children.only(children);

    if ( /*#__PURE__*/React__default.isValidElement(children)) {
      newChildren = /*#__PURE__*/React__default.cloneElement(children, _objectSpread(_objectSpread({}, children.props), {}, {
        children: /*#__PURE__*/React__default.createElement(InnerItem, innerItemProps, children.props.children)
      }));
    } else {
      throw new Error("Invalid children provided.");
    }
  }

  return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(RadixDropdownMenu.Item, _extends({
    onSelect: onClick,
    className: classes,
    ref: ref,
    asChild: asChild
  }, props), newChildren));
});

export { DropdownMenuItem, DropdownMenuSubTrigger };
//# sourceMappingURL=dropdown-menu-item.js.map
